import { action, observable } from 'mobx';

import { checkFanZoneStatus, getAnchors } from '../pages/Anchors/services';

const NAKED_NEWS_LIVE_DATA = {
  id: 241,
  name: 'Naked News Live',
};

class AnchorStore {
  @observable isAnchorLive = undefined;
  @observable isNakedNewsLive = false;
  @observable anchors = {};
  @observable anchorsWithFanzone = [];

  @action setIsAnchorLive = (value) => {
    this.isAnchorLive = value;
  };

  @action setIsNakedNewsLive = (value) => {
    this.isNakedNewsLive = value;
  };

  @action setAnchorsWithFanzone = async () => {
    if (this.anchorsWithFanzone?.length) {
      return;
    }

    const { error, data } = await checkFanZoneStatus();

    if (!error) {
      this.anchorsWithFanzone = data?.data;
      Promise.resolve(data);
    }
  };

  @action setAnchors = async () => {
    if (this.anchors?.currentAnchors?.length) {
      return;
    }
    const { error, data } = await getAnchors();

    if (!error) {
      const anchors = data.data;
      anchors.currentAnchors.push(NAKED_NEWS_LIVE_DATA);
      this.anchors = anchors;
      Promise.resolve(data);
    }
  };

  @action getAnchorData = (id) => {
    const currentAnchor = this.anchors?.currentAnchors?.find((anchor) => parseInt(id, 10) === anchor?.id);
    const guestAnchor = this.anchors?.guestAnchors?.find((anchor) => parseInt(id, 10) === anchor?.id);

    return currentAnchor || guestAnchor;
  };
}

export default new AnchorStore();
